<template>
  <el-dialog v-model="modal.visible" title="嘉宾类型" :width="600">
    <el-form ref="formRef" :label-width="138" :model="formData" :rules="rules">
      <el-form-item label="嘉宾类型" prop="type">
        <el-radio-group v-model="formData.type">
          <el-radio v-for="(item, index) in dataSource" :key="index" :label="item.type">{{ item.title }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formData.type === importantGuestStr" label="重要嘉宾类型" prop="tag">
        <el-select v-model="formData.tag" placeholder="请选择" style="width: 100%">
          <el-option v-for="(item, index) in dataSource[1].list" :key="index" :label="item.name" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="formData.type === importantGuestStr && formData.tag === '8'"
        label="其他重要嘉宾类型"
        prop="remark"
      >
        <el-input v-model="formData.remark" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="modal.close()">取消</el-button>
      <el-button type="primary" @click="confirm(formRef)">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { ref, reactive, computed, defineProps, defineExpose, defineEmits, getCurrentInstance } from 'vue'
  import { useModal } from '@/hooks/useModal'
  import { editGuestType } from '@/api/exhibitionManage'
  import { useRoute } from 'vue-router'

  const route = useRoute()
  const { meetingCode = '' } = route.query

  const props = defineProps({
    dataSource: {
      type: Array,
      default: () => [],
    },
  })

  const emit = defineEmits(['fetch-data'])

  const formRef = ref()

  const { proxy } = getCurrentInstance()

  const formData = reactive({
    code: '',
    tag: '',
    type: '',
    remark: '',
    meetingCode,
  })

  const rules = {
    tag: [
      {
        required: true,
        message: '请选择嘉宾类型',
        trigger: 'change',
      },
    ],
    type: [
      {
        required: true,
        message: '请选择重要嘉宾类型',
        trigger: 'change',
      },
    ],
    remark: [
      {
        required: true,
        message: '请输入重要嘉宾类型',
        trigger: 'change',
      },
    ],
  }

  const ordinaryGuestStr = computed(() => props.dataSource[0].title)
  const importantGuestStr = computed(() => props.dataSource[1].title)

  const modal = useModal({
    onOpen(row) {
      formData.code = row.code
      formData.type = row.myType
      formData.tag = row.myTag
      formData.remark = row.myRemark
    },
    onClose() {
      Object.keys(formData).forEach((k) => (formData[k] = ''))
      formRef.value.resetFields()
    },
  })

  function confirm(formEl) {
    if (!formEl) return
    formEl.validate((valid) => {
      if (!valid) return

      if (formData.type === ordinaryGuestStr.value) {
        formData.tag = ''
        formData.remark = ''
      }

      editGuestType({ ...formData }).then(() => {
        proxy.$baseMessage('操作成功', 'success', 'vab-hey-message-success')
        modal.close()
        emit('fetch-data')
      })
    })
  }

  defineExpose({
    open: modal.open,
  })
</script>

<style lang="scss" scoped></style>
